import { render, staticRenderFns } from "./XmEasyMultipleSelect.vue?vue&type=template&id=40addf8e&scoped=true"
import script from "./XmEasyMultipleSelect.vue?vue&type=script&lang=js"
export * from "./XmEasyMultipleSelect.vue?vue&type=script&lang=js"
import style0 from "./XmEasyMultipleSelect.vue?vue&type=style&index=0&id=40addf8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40addf8e",
  null
  
)

export default component.exports